// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(true);
// Module
exports.push([module.id, "#introducedCafeModal .modal-title{width:100%}\n", "",{"version":3,"sources":["/home/sysadmin/apps/rsee-panel/src/screens/introducedCafes/introducedCafes.scss"],"names":[],"mappings":"AAAA,kCAEI,UAAW","file":"introducedCafes.scss","sourcesContent":["#introducedCafeModal{\n  .modal-title {\n    width: 100%;\n  }\n}"]}]);
// Exports
module.exports = exports;
